import cogoToast from 'cogo-toast';
import { takeLatest, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_MANUAL_GOLF_COACHES, GET_MANUAL_GOLF_COACHES_SUCCESS, GET_MANUAL_GOLF_COACHES_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getManualGolfCoaches() {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/manual/golf-lesson/coaches`,
      method: 'GET',
      headers: filteredHeaders,
    });

    if (response.status === 200) {
      const fileUrl = response?.data?.results?.url;
      if (fileUrl) {
        window.open(fileUrl, '_blank');
      } else {
        cogoToast.info('No coach mapping available');
      }

      yield put({ type: GET_MANUAL_GOLF_COACHES_SUCCESS, payload: response?.data });
    } else {
      cogoToast.error(response?.response?.data?.message || 'Failed to fetch coach mapping');
      yield put({ type: GET_MANUAL_GOLF_COACHES_ERROR, payload: response?.response?.data?.message });
    }
  } catch (error) {
    cogoToast.error('Failed to fetch coach mapping');
    yield put({ type: GET_MANUAL_GOLF_COACHES_ERROR, payload: error });
  }
}

export function* watchGetManualGolfCoaches() {
  yield takeLatest(GET_MANUAL_GOLF_COACHES, getManualGolfCoaches);
}

function* getManualGolfCoachesSaga() {
  yield all([fork(watchGetManualGolfCoaches)]);
}

export default getManualGolfCoachesSaga;
